import { VaultRoles } from '../../../utils/roles/client-roles';

export const timeZones = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Australia/Sydney',
];

export const corpusOptions = [
  { value: 'MAIL', label: 'Mail', disabled: false },
  { value: 'HANGOUTS_CHAT', label: 'Chat', disabled: false },
  { value: 'CALENDAR', label: 'Calendar', disabled: false },
  { value: 'DRIVE', label: 'Drive', disabled: false },
  { value: 'GROUPS', label: 'Groups', disabled: false },
  { value: 'GEMINI', label: 'Gemini App', disabled: false },
];

export const dataScopeOptions = [
  { value: 'ALL_DATA', label: 'All Data', disabled: false },
  // { value: 'HELD_DATA', label: 'Held Data', disabled: false },
  { value: 'UNPROCESSED_DATA', label: 'Unprocessed Data', disabled: false },
];

export const searchMethodLabelMap: Record<string, string> = {
  ORG_UNIT: 'Org Unit ID',
  SHARED_DRIVE: 'Shared Drive ID',
  TEAM_DRIVE: 'Team Drive ID',
  SITES_URL: 'Sites URLs (comma separated)',
  ROOM: 'Room IDs (comma separated)',
};

export const searchMethodOptions = [
  { value: 'ACCOUNT', label: 'Account', disabled: false },
  //   { value: 'ENTIRE_ORG', label: 'Entire Org', disabled: true },
  { value: 'ORG_UNIT', label: 'Organizational Unit', disabled: false },
  //   { value: 'TEAM_DRIVE', label: 'Team Drive', disabled: true },
  { value: 'SHARED_DRIVE', label: 'Shared Drive', disabled: false },
  //   { value: 'SITES_URL', label: 'Sites URL', disabled: true },
  //   { value: 'ROOM', label: 'Room', disabled: true },
];

export const permissionByCorpus: Record<string, string | undefined> = {
  MAIL: VaultRoles.CreateGmailVaultExport?.value,
  HANGOUTS_CHAT: VaultRoles.CreateChatVaultExport?.value,
  GEMINI: VaultRoles.CreateGeminiVaultExport?.value,
  CALENDAR: VaultRoles.CreateCalendarVaultExport?.value,
  DRIVE: VaultRoles.CreateDriveVaultExport?.value,
  GROUPS: VaultRoles.CreateGroupsVaultExport?.value,
};

export const exportFormatOptionsByCorpus: Record<
  string,
  { value: string; label: string; disabled: boolean }[]
> = {
  MAIL: [
    { value: 'MBOX', label: 'MBOX', disabled: false },
    { value: 'PST', label: 'PST', disabled: false },
  ],
  HANGOUTS_CHAT: [
    { value: 'MBOX', label: 'MBOX', disabled: false },
    { value: 'PST', label: 'PST', disabled: false },
  ],
  CALENDAR: [
    { value: 'PST', label: 'PST', disabled: false },
    { value: 'ICS', label: 'ICS', disabled: false },
  ],
  GROUPS: [
    { value: 'MBOX', label: 'MBOX', disabled: false },
    { value: 'PST', label: 'PST', disabled: false },
  ],
  GEMINI: [{ value: 'XML', label: 'XML', disabled: false }],
};
